module.exports = require("@price-point/configuration");